{
  "version": 1,
  "asset_id": "c050e34a-89be-462c-b21f-e55e5971d2dd",
  "project_id": "0fdb3b9c-5222-4717-8611-0aaf6da51cb4",
  "url": "/__l5e/assets-v1/c050e34a-89be-462c-b21f-e55e5971d2dd/hero-video.mp4",
  "r2_key": "a/v1/0fdb3b9c-5222-4717-8611-0aaf6da51cb4/c050e34a-89be-462c-b21f-e55e5971d2dd/hero-video.mp4",
  "original_filename": "hero-video.mp4",
  "size": 77869487,
  "content_type": "video/mp4",
  "created_at": "2026-06-16T07:28:42Z"
}
